// extracted by mini-css-extract-plugin
export default {"padded-description":"PhotoWithDescription_padded-description__1x48s"};